import { MatPaginator } from '@angular/material/paginator';
import { Sort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Observable, Subject } from 'rxjs';

interface DataProviderResponse<T> {
  // smth dummy but I really have no ideas
  [propName: string]: any;
}

export abstract class DataProvider<T> {

  public loadingState = false;
  public refreshState = new Subject<number>();

  private _counter = 1;

  public abstract loadData(): Observable<DataProviderResponse<T>>;

  public reload(): void {
    this.refreshState.next(this._counter++);
  }
}

export class PageQuery {

  private defaultSize = 20;
  public pageSize: number;

  constructor(
    public currentIndex = 0,
    itemsPerPage?: number) {
    this.pageSize = itemsPerPage === undefined ? this.defaultSize : itemsPerPage;
  }
}

export abstract class PagedDataProvider<T> extends DataProvider<T> {

  public paginator: MatPaginator;
  public dataSource: MatTableDataSource<T> = new MatTableDataSource();
  public page: PageQuery = new PageQuery();

  private _data$ = this.dataSource.connect();

  public addRows(arg: T | T[]) {
    const rows: T[] = Array.isArray(arg) ? arg : [arg];
    const previousData = this._data$.getValue();
    const newData = [...rows, ...Array.isArray(previousData) ? previousData : []];

    this._data$.next(newData);
  }

  public modifyRow(id: number, newValue: T);
  public modifyRow(searchKey: string, searchValue: any, newValue: T);
  public modifyRow(...args) {
    const _prevValues = this._data$.getValue();
    const newValue = args[args.length - 1];

    let idx: number;

    if (args.length === 3) {
      const [searchKey, searchValue] = args;
      idx = _prevValues.findIndex(val => val[searchKey] === searchValue);
    } else {
      idx = args[0];
    }

    _prevValues.splice(idx, 1, newValue);
    this._data$.next([..._prevValues]);
  }

  public deleteRow(id: number);
  public deleteRow(searchKey: string, searchValue: any);
  public deleteRow(...args) {
    const _prevValues = this._data$.getValue();
    let idx: number;

    if (args.length === 2) {
      const [searchKey, searchValue] = args;
      idx = _prevValues.findIndex(val => val[searchKey] === searchValue);
    } else {
      idx = args[0];
    }

    _prevValues.splice(idx, 1);
    this._data$.next([..._prevValues]);
  }
}

export abstract class SearchablePagedDataProvider<T, K> extends PagedDataProvider<T> {
  public searchParams: K;
}

export abstract class SortableDataProvider<T, K> extends PagedDataProvider<T> {

  protected sortParams: K;

  public abstract sort(params: Sort);
}


